const getNestedValue = (obj, path) => {
  return path.split(".").reduce((current, key) => current && current[key], obj);
};

export const validateProductForm = (data) => {
  const requiredFields = [
    // "plateNumber",
    "carName",
    "askingPrice",
    "carBrand",
    "carModel",
    "vehicleType",
    //"registrationDate",
    "city",
    "district",
    // "manufacturedYear",
    "specifications.transmission",
    "color",
    // "blueCardFile",
  ];

  var validFieldCount = 0;

  requiredFields.forEach((field) => {
    const value = getNestedValue(data, field);
    if (value !== undefined && value !== null && value !== "") {
      validFieldCount += 1;
    }
  });

  return validFieldCount === requiredFields.length;
};

export const validateNewProductForm = (data) => {
  const requiredFields = [
    "carName",
    "askingPrice",
    "carBrand",
    "carModel",
    "city",
    "district",
    // "manufacturedYear",
    "specifications.transmission",
    // "vehicleType",
  ];

  var validFieldCount = 0;

  requiredFields.forEach((field) => {
    const value = getNestedValue(data, field);
    if (value !== undefined && value !== null && value !== "") {
      validFieldCount += 1;
    }
  });

  return validFieldCount === requiredFields.length;
};

export const validateUpload = (selectedFiles, currentImages) => {
  // console.log(selectedFiles);
  // console.log(currentImages);
  const selectedTotal = selectedFiles.reduce((n, { size }) => n + size, 0);
  const currentTotal = currentImages
    .map((el) => el.metadata)
    .reduce((n, { size }) => n + size, 0);

  const selectedTotalMB = selectedTotal / 1048576;
  const currentTotalMB = currentTotal / 1048576;

  const overAllTotal = selectedTotalMB + currentTotalMB;
  const overImageLength = selectedFiles.length + currentImages.length;

  // if (overAllTotal <= 20 && overImageLength >= 1 && overImageLength <= 9) {
  if (overImageLength >= 1 && overImageLength <= 20) {
    return true;
  } else {
    return false;
  }
};

export const validateLimitUpload = (selectedFiles, currentImages) => {
  const overImageLength = selectedFiles.length + currentImages.length;

  if (overImageLength < 20) {
    return true;
  } else {
    return false;
  }
};
